import {html, css, LitElement} from 'lit';
import {customElement, property} from 'lit/decorators.js';
@customElement('gmk-skillbar')
export class SkillbarElement extends LitElement {

    static styles = css`
        .skillbar-labels {
        display: flex;
        justify-content: space-between;
        margin: 5px 0;
        }
        .skillbar-labels > * {
        width: 50%;
        font-size: 14px;
        color: #fff;
        display: block;
        }
        .skillbar-maxlabel {
        text-align: right;
        }
        .skillbar {
        height: 34px;
        background: #1F1F1F;
        display: flex;
        justify-content: space-between;
        position: relative;
        }
        .skillbar-value {
        color: #fff;
        position: absolute;
        top: 5px;
        left: 25px;
        }
        .skillbar-value.max {
        right: 25px;
        left: unset;
        }
        .skillbar-bar {
        background-color: #cdd600;
        }
    `;
    @property({type: String}) label = '';
    @property({type: Number}) value = 0;
    @property({type: Number}) maxvalue = 0;


    render() {
        return html`
        <div class="skillbar-labels">
            <span class="skillbar-label">${this.label}</span>
            <span class="skillbar-maxlabel">Ø max. im Team</span>
        </div>
        <div class="skillbar">
            <div class="skillbar-bar" style="width: ${Math.round(this.value/this.maxvalue*100)}%;"></div>
            <span class="skillbar-value">${this.value}</span>
            <span class="skillbar-value max">${this.maxvalue}</span>
        </div>
        `;
    }
}
